// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kot-coach-start {
  margin: 10px 0 0;
  font-size: 14px;
}

.kot-coach-start--compact {
  margin: 12px 0 0;
  padding-top: 12px;
  border-top: 1px solid rgba(8, 119, 188, 0.2);
}

.kot-coach-start__progress {
  background: #e3f2fd;
  border: 1px solid #90caf9;
  color: #0d47a1;
  padding: 8px 10px;
  border-radius: 6px;
  margin-bottom: 8px;
}

.kot-coach-start__progress-label {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.kot-coach-start__progress-hint {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.9;
}

.kot-coach-start__ready {
  background: #e8f5e9;
  color: #1b5e20;
  border: 2px solid #66bb6a;
  padding: 14px 14px 16px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(27, 94, 32, 0.12);
}

.kot-coach-start__message {
  margin: 0 0 8px;
  line-height: 1.45;
}

.kot-coach-start__rotation {
  margin: 0 0 8px;
  padding-left: 18px;
  font-size: 12px;
}

.kot-coach-start__cta {
  margin-top: 12px;
}

.kot-coach-start__button {
  display: block;
  width: 100%;
  min-height: 52px;
  box-sizing: border-box;
  background: #0877bc;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 14px 20px;
  font-weight: 700;
  font-size: 17px;
  line-height: 1.25;
  letter-spacing: 0.02em;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.kot-coach-start__button--ready {
  background: linear-gradient(180deg, #0a8ad4 0%, #0669a8 100%);
  box-shadow: 0 4px 14px rgba(8, 119, 188, 0.45);
}

.kot-coach-start__button--ready:hover:not(:disabled) {
  background: linear-gradient(180deg, #0b95e3 0%, #0774b8 100%);
}

.kot-coach-start__button--ready:active:not(:disabled) {
  transform: translateY(1px);
  box-shadow: 0 2px 8px rgba(8, 119, 188, 0.35);
}

.kot-coach-start__button:focus-visible {
  outline: 3px solid #ffeb3b;
  outline-offset: 2px;
}

.kot-coach-start__button:disabled {
  background: #b0bec5;
  color: #eceff1;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}

.kot-coach-start__error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 10px;
  background: #ffebee;
  border: 1px solid #ef9a9a;
  color: #b71c1c;
  border-radius: 6px;
  font-size: 12px;
}

.kot-coach-start-slot--exercise-card {
  margin-top: 12px;
  width: 100%;
}

.kot-coach-start-slot--exercise-card .kot-coach-start__ready {
  background: #fff;
  border-color: #81c784;
}

.kot-coach-start-slot--exercise-card .kot-coach-start__button {
  min-height: 56px;
  font-size: 18px;
}

.kot-settings--embedded .kot-coach-start__ready {
  background: #fff;
}

.kot-settings--embedded .kot-coach-start__button--ready {
  min-height: 56px;
  font-size: 18px;
}

.kot-coach-start-slot--header {
  display: inline-flex;
  flex-shrink: 0;
}

.kot-coach-start__button--header {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-height: 42px;
  padding: 10px 16px;
  font-size: 14px;
  white-space: nowrap;
}

.kot-coach-start__button--header.kot-coach-start__button--ready {
  min-height: 42px;
  font-size: 15px;
}

.session-info-card .kot-coach-start__button--header {
  min-height: 42px;
  font-size: 14px;
}

.session-info-card .kot-coach-start__button--header.kot-coach-start__button--ready {
  min-height: 42px;
  font-size: 15px;
  box-shadow: 0 2px 10px rgba(8, 119, 188, 0.4);
}

.kot-coach-start__button--actions-bar {
  flex: 1 1 auto;
  min-width: 0;
  max-width: none;
}

@media (min-width: 600px) {
  .kot-coach-start__button--actions-bar {
    flex: 1 1;
  }
}

.kot-coach-stop__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-sizing: border-box;
  border: 2px solid #f57c00;
  background: #fff3e0;
  color: #e65100;
  border-radius: 8px;
  padding: 10px 14px;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.25;
  cursor: pointer;
  touch-action: manipulation;
  white-space: nowrap;
}

.kot-coach-stop__button:hover:not(:disabled) {
  background: #ffe0b2;
}

.kot-coach-stop__button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.kot-coach-stop__button--actions-bar {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 42px;
}

@media (min-width: 600px) {
  .kot-coach-stop__button--actions-bar {
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/KotCoachStartRound.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,SAAW;EACb;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAW;EACb;AACF","sourcesContent":[".kot-coach-start {\n  margin: 10px 0 0;\n  font-size: 14px;\n}\n\n.kot-coach-start--compact {\n  margin: 12px 0 0;\n  padding-top: 12px;\n  border-top: 1px solid rgba(8, 119, 188, 0.2);\n}\n\n.kot-coach-start__progress {\n  background: #e3f2fd;\n  border: 1px solid #90caf9;\n  color: #0d47a1;\n  padding: 8px 10px;\n  border-radius: 6px;\n  margin-bottom: 8px;\n}\n\n.kot-coach-start__progress-label {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.kot-coach-start__progress-hint {\n  display: block;\n  margin-top: 4px;\n  font-size: 12px;\n  opacity: 0.9;\n}\n\n.kot-coach-start__ready {\n  background: #e8f5e9;\n  color: #1b5e20;\n  border: 2px solid #66bb6a;\n  padding: 14px 14px 16px;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(27, 94, 32, 0.12);\n}\n\n.kot-coach-start__message {\n  margin: 0 0 8px;\n  line-height: 1.45;\n}\n\n.kot-coach-start__rotation {\n  margin: 0 0 8px;\n  padding-left: 18px;\n  font-size: 12px;\n}\n\n.kot-coach-start__cta {\n  margin-top: 12px;\n}\n\n.kot-coach-start__button {\n  display: block;\n  width: 100%;\n  min-height: 52px;\n  box-sizing: border-box;\n  background: #0877bc;\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 14px 20px;\n  font-weight: 700;\n  font-size: 17px;\n  line-height: 1.25;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.kot-coach-start__button--ready {\n  background: linear-gradient(180deg, #0a8ad4 0%, #0669a8 100%);\n  box-shadow: 0 4px 14px rgba(8, 119, 188, 0.45);\n}\n\n.kot-coach-start__button--ready:hover:not(:disabled) {\n  background: linear-gradient(180deg, #0b95e3 0%, #0774b8 100%);\n}\n\n.kot-coach-start__button--ready:active:not(:disabled) {\n  transform: translateY(1px);\n  box-shadow: 0 2px 8px rgba(8, 119, 188, 0.35);\n}\n\n.kot-coach-start__button:focus-visible {\n  outline: 3px solid #ffeb3b;\n  outline-offset: 2px;\n}\n\n.kot-coach-start__button:disabled {\n  background: #b0bec5;\n  color: #eceff1;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n.kot-coach-start__error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 8px 10px;\n  background: #ffebee;\n  border: 1px solid #ef9a9a;\n  color: #b71c1c;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.kot-coach-start-slot--exercise-card {\n  margin-top: 12px;\n  width: 100%;\n}\n\n.kot-coach-start-slot--exercise-card .kot-coach-start__ready {\n  background: #fff;\n  border-color: #81c784;\n}\n\n.kot-coach-start-slot--exercise-card .kot-coach-start__button {\n  min-height: 56px;\n  font-size: 18px;\n}\n\n.kot-settings--embedded .kot-coach-start__ready {\n  background: #fff;\n}\n\n.kot-settings--embedded .kot-coach-start__button--ready {\n  min-height: 56px;\n  font-size: 18px;\n}\n\n.kot-coach-start-slot--header {\n  display: inline-flex;\n  flex-shrink: 0;\n}\n\n.kot-coach-start__button--header {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  min-height: 42px;\n  padding: 10px 16px;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.kot-coach-start__button--header.kot-coach-start__button--ready {\n  min-height: 42px;\n  font-size: 15px;\n}\n\n.session-info-card .kot-coach-start__button--header {\n  min-height: 42px;\n  font-size: 14px;\n}\n\n.session-info-card .kot-coach-start__button--header.kot-coach-start__button--ready {\n  min-height: 42px;\n  font-size: 15px;\n  box-shadow: 0 2px 10px rgba(8, 119, 188, 0.4);\n}\n\n.kot-coach-start__button--actions-bar {\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: none;\n}\n\n@media (min-width: 600px) {\n  .kot-coach-start__button--actions-bar {\n    flex: 1 1 0;\n  }\n}\n\n.kot-coach-stop__button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  box-sizing: border-box;\n  border: 2px solid #f57c00;\n  background: #fff3e0;\n  color: #e65100;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1.25;\n  cursor: pointer;\n  touch-action: manipulation;\n  white-space: nowrap;\n}\n\n.kot-coach-stop__button:hover:not(:disabled) {\n  background: #ffe0b2;\n}\n\n.kot-coach-stop__button:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.kot-coach-stop__button--actions-bar {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 42px;\n}\n\n@media (min-width: 600px) {\n  .kot-coach-stop__button--actions-bar {\n    flex: 1 1 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
